import api from './api';

const listingTypes = {
  'active-sales': 'active-sales',
  'rentals': 'rentals',
  'short-term-rentals': 'short-term-rentals',
  'past-sales': 'past-sales',
  'past-rentals': 'past-rentals',
};

export const getListings = async (type) => {
  try {
    const response = await api.get(`/api/listings/${listingTypes[type] || type}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching listings:', error);
    throw error;
  }
};

export const createListing = async (type, data) => {
  try {
    const response = await api.post(`/api/listings/${listingTypes[type] || type}`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating listing:', error);
    throw error;
  }
};

export const updateListing = async (type, id, data) => {
  try {
    const response = await api.put(`/api/listings/${listingTypes[type] || type}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating listing:', error);
    throw error;
  }
};

export const deleteListing = async (type, id) => {
  try {
    const response = await api.delete(`/api/listings/${listingTypes[type] || type}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting listing:', error);
    throw error;
  }
};

export const uploadImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/api/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading image:', error);
    throw error;
  }
};

export const getImageUrl = (imageId) => {
  if (!imageId) return null;
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  return `${baseUrl}/api/images/${imageId}`;
};

export const deleteImage = async (imageId) => {
  try {
    const response = await api.delete(`/api/images/${imageId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting image:', error);
    throw error;
  }
};




